import { Card, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CoreSearchBar from "../../../app/core/components/CoreSearch/CoreSearch";
import { useGetUserStudiosQuery } from "../../api/user/associaStudioApi";
import { SkeletonsHorizontalCard } from "../../common/LoadingStuff/Skeletons/SkeletonsHorizontalCard";

const AssociaStudioPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const studioId = useSelector((state) => state.app.studioId);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 750);
    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  const {
    data: userStudioList,
    isLoading: isLoadingUserStudioList,
    isFetching: isFetchingUserStudioList,
  } = useGetUserStudiosQuery({ query: debouncedSearchTerm });

  return (
    <>
      {studioId ? (
        <span className="text-gray">{`${t("AlreadyAssociated")}`}</span>
      ) : (
        <div>
          <h1 className="text-center mb-3">{`${t("SearchStudio")}`}</h1>
          <p className="text-center mt-0">{` ${t("SearchStudioExt")} `}</p>
          <div className="flex items-center justify-center pb-4 space-x-4">
            <div>
              <CoreSearchBar
                searchTerm={searchTerm}
                handleChange={setSearchTerm}
              />
            </div>
          </div>
          <h3>{t("ResearchResult")}</h3>

          <Grid container spacing={2}>
            {isLoadingUserStudioList || isFetchingUserStudioList ? (
              <SkeletonsHorizontalCard length={18} />
            ) : (
              userStudioList?.Data?.map((studio) => (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={studio.id}>
                  <Card
                    className="cursor-pointer rounded-lg"
                    elevation={4}
                    onClick={() =>
                      navigate(
                        `/auth/user/${t("associate-studio")}/${studio.id}`
                      )
                    }
                  >
                    <div
                      className=" flex justify-center items-center"
                      style={{
                        height: "140px",
                      }}
                    >
                      <img
                        alt={studio.logoImageUrl ? "logo" : "placeholder"}
                        src={
                          studio.logoImageUrl
                            ? studio.logoImageUrl
                            : "/img/placeholder-logo.svg"
                        }
                        style={{
                          maxWidth: "100px",
                          maxHeight: "100px",
                        }}
                      />
                    </div>
                  </Card>
                  <h4 className="text-center">{studio.name}</h4>
                </Grid>
              ))
            )}
          </Grid>
        </div>
      )}
    </>
  );
};

export default AssociaStudioPage;
